import './App.css';
import { Routes } from 'react-router-dom';
import './components/includes/Responsive.css';
import './components/includes/Header.css';
import './components/includes/Headernew.css';
import './components/includes/HeaderMainpage.css';
import './components/includes/ProductCategoryGrid.css';
import './components/Mainpage.css';
import './components/KonfiguratorDetail.css';
import './components/includes/Block404.css';
import './components/includes/GeneralCss.css';
import './components/includes/Footer.css';
import './components/Service.css';
import './components/KonfiguratorResponsive.css';
import './components/Konfigurator.css';
import './components/Jobcenter.css';
import './components/includes/NeedHelp.css';
import './components/Trainings.css';
import React, { useEffect } from 'react';

import { RoutesComponent } from './utility/routing/routes-component';
import { MetaLocaleRoutes } from 'components/meta-tags/meta-locale-routes';
import { useLocale } from 'hooks/use-locale';
import { PrerenderRedirectMeta } from 'components/meta-tags/prerender-redirect-meta';
import { SeoCrawlerRemoveCookieBanner } from 'components/meta-tags/seo-crawler-remove-cookie-banner';
import { EnsureTrailingSlash } from 'components/meta-tags/ensure-trailing-slash';
import { StaticCanonicalMetaTag } from 'components/meta-tags/static-canonical-meta-tag';
import { setPrerenderBehaviour, Utility } from 'utility/utility';
import { DefaultErrorBoundary } from 'components/error-boundaries/default-error-boundary/default-error-boundary';

if (Utility.isClientPrerender() || window.location.href.includes('localhost')) {
  window.prerenderReady = false;
  setPrerenderBehaviour('dom_idle', 'App.js', 'Set default behaviour');
}

function App() {
  const locale = useLocale();

  useEffect(() => {
    // Define the font URL(s) from your S3 bucket
    const fontUrl = 'https://strapiwmc4hstore.blob.core.windows.net/website-assets/Inter-Regular.ttf';

    // Create a link element for the font
    const fontLink = document.createElement('link');
    fontLink.href = fontUrl;
    fontLink.rel = 'stylesheet';

    // Append the link to the head of the document
    document.head.appendChild(fontLink);

    // Optionally, you can load multiple fonts by creating additional link elements

    return () => {
      // Clean up the link element when the component unmounts
      document.head.removeChild(fontLink);
    };
  }, []);

  useEffect(() => {
    if (!locale) return;
    const lang = locale.split('-')[0];
    document.documentElement.lang = lang;
  }, [locale]);

  /*useEffect(() => {
    if (!locale || Utility.isClientCrawler()) return;

    const lang = locale.split('-')[0];
    document.documentElement.lang = lang;

    const lastLocaleReset = window.localStorage.getItem('last-locale-reset');

    if (!lastLocaleReset || Number(lastLocaleReset) < 1737369686000) {
      Utility.fetchLocale().then((localeData) => {
        window.localStorage.setItem('last-locale-reset', Date.now());
        if (localeData === locale) return;
        const path = `/${localeData}/`;
        window.location.pathname = path;
      });
    }
  }, [locale]);*/

  return (
    <DefaultErrorBoundary>
      <PrerenderRedirectMeta />
      <SeoCrawlerRemoveCookieBanner />
      <MetaLocaleRoutes />
      <EnsureTrailingSlash />
      <StaticCanonicalMetaTag />
      {/* secondary error boundary for the page itself. Needed to accuratly mark statuscodes for prerender */}
      <DefaultErrorBoundary>
        <Routes>{RoutesComponent()}</Routes>
      </DefaultErrorBoundary>
    </DefaultErrorBoundary>
  );
}

export default App;
